import { render, staticRenderFns } from "./GpsSurveillance.vue?vue&type=template&id=0c822ca1&"
import script from "./GpsSurveillance.vue?vue&type=script&lang=js&"
export * from "./GpsSurveillance.vue?vue&type=script&lang=js&"
import style0 from "./GpsSurveillance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports